
<footer>
    <!-- Inizio Codice Shinystat -->
    <div class="shiny">
        <script type="text/javascript" src="http://codice.shinystat.com/cgi-bin/getcod.cgi?USER=corsaro22"></script>
        <a href="http://www.shinystat.com/it" target="_top" >
        <img src="http://www.shinystat.com/cgi-bin/shinystat.cgi?USER=corsaro22" alt="Statistiche" /></a>
    </div><br>
    <!-- Fine Codice Shinystat -->
    <div class="content-footer">
        <div class="copy-right">
            <p>Copyright (c) 2010 ilcorsaronero. All rights reserved.</p>
        </div>
    </div>
</footer>
